export const engagementCampaignsCampaignsWithRepliedToSms = "/engagement/campaigns/campaigns_with_replied_to_sms";
